<template>
    <div class="Info">
        <!-- <div class="InfoTit">个人信息</div> -->
        <div class="StepJiBen">
            <div class="StepJiBenItem">
                <div class="StepJiBenItemTit"><span class="Tit">姓名</span></div>
                <div class="StepJiBenItemVal">
                    <el-input placeholder="请输入" v-model="SetData.nickname"></el-input>
                </div>
            </div>
            <div class="StepJiBenItem">
                <div class="StepJiBenItemTit"><span class="Tit">性别</span></div>
                <div class="StepJiBenItemVal">
                    <el-radio-group v-model="SetData.gender">
                        <el-radio :label="1">男</el-radio>
                        <el-radio :label="2">女</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="StepJiBenItem">
                <div class="StepJiBenItemTit"><span class="Tit">手机号</span></div>
                <div class="StepJiBenItemVal">
                    <el-input placeholder="请输入" v-model="SetData.mobile" disabled></el-input>
                </div>
            </div>
            <div class="StepJiBenItem">
                <div class="StepJiBenItemTit"><span class="Tit">邮箱</span></div>
                <div class="StepJiBenItemVal">
                    <el-input placeholder="请输入" v-model="SetData.email"></el-input>
                </div>
            </div>
        </div>
        <div class="OrderBtns">
            <div class="OrderBtn BgBlue" @click="SetInfo">修改</div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                SetData:{
                    mobile:"",
                },
            }
        },
        mounted() {
            this.SetData = localStorage.getItem("User")?JSON.parse(localStorage.getItem("User")).userinfo:"";
        },
        methods: {
            SetInfo(){
                var Quy = JSON.parse(JSON.stringify(this.SetData))
                this.$post("api/user/profile",Quy).then(res => {
                     if(res.data.code == 1){
                         var Obj = {userinfo: this.SetData,}
                         localStorage.setItem("User", JSON.stringify(Obj));
                         this.$emit("UpData",1)
                         this.$message.success(res.data.msg)
                     }else{
                         this.$message.error(res.data.msg)
                     }
                })  
            },
        },
    }
</script>
<style scoped>
    .InfoTit{
        padding: 20px 0;
        color: #000;
        font-size: 16px;
    }
   .StepJiBen{
       margin-left: 5vw;
       width: 70%;
   }
   .StepJiBenItem{
       display: flex;
       align-items: center;
       margin-bottom: 40px;
   }
   .StepJiBenItemTit{
       width: 135px;
       text-align: right;
       margin-right: 20px;
   }
   .StepJiBenItemTit .Tit{
       font-weight: 400;
       font-size: 16px;
       color: #999;
   }
   .StepJiBenItemVal{
       flex: 1;
   }
   .StepJiBenItemVal .WidMax{
       width: 100%;
   }
   .OrderBtns{
       display: flex;
       align-items: center;
       justify-content: center;
       margin: 20px 0;
   }
   .OrderBtn{
        padding: 5px 40px;
        background: #FFFFFF;
        font-weight: 400;
        font-size: 18px;
        color: #0385EB;
        border-radius: 30px;
        border: 2px solid #0385EB;
        margin-right: 20px;
        cursor: pointer;
   }
   .OrderBtn.BgBlue{
       background: #0385EB;
       color: #fff;
   }
   @media only screen and (max-width: 550px) {
       .InfoTit{
           display: none;
       }
      .StepJiBen{
          width: 100%;
          margin: 0;
      }
      .StepJiBenItemTit{
          width: 80px;
      }
      .StepJiBenItemTit .Tit{
          font-size: 16px;
      }
   }
</style>